import React, { useEffect, useMemo, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import {
  replaceWorkEntriesProjectTrack,
  saveUpdateDescriptionTask,
} from "../../../../store/slices/managerEditTrackingEntries";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import {
  deleteDescriptionTask,
  fetchDescriptionTasksProjectTracking,
  fetchDescriptionTasks,
} from "../../../../store/slices/DescriptionTask";
import {
  deleteTask,
  fetchWorkEntriesProjectTracking,
} from "../../../../store/slices/workentriesSlice";
import { setProjectReadTrue } from "../../../../store/slices/readSlice";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import {
  formatAmountComma,
  formatAmountForInput,
  validateAmountValue,
  parseAmountNumber,
} from "../../../../utils/decimalAmountUtils";
import {
  consolidateTrainingExpenseRowsForDisplay,
  getLiveTrainingRollupForOpsAssigneeProject,
  isTrainingExpenseDisplayRow,
} from "../../../../utils/trainingOtherExpenseSync";

const ShowAssigedTableManager = ({
  refreshAssign,
  row,
  emp,
  setIsLoading,
  employees,
  matchedOldRowDesctiption,
  matchedOldRowEntries,
  showListState,
  clickedPersonId,
  setClickedPersonId,
  allAssignedForProject = [],
  projectDescriptionEntries = [],
  isViewOnly = false,
}) => {
  const sanitizeDecimalInput = (inputValue) => {
    const cleaned = String(inputValue ?? "").replace(/[^0-9.]/g, "");
    const [integerPart, ...decimalParts] = cleaned.split(".");
    if (decimalParts.length === 0) return integerPart;
    return `${integerPart}.${decimalParts.join("")}`;
  };
  const roundHours = (value) => Number((Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2));
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const selectedProjectId = row._id;
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { projects } = useSelector((state) => state.projects);
  const [projectTasksEntriesAssiged, setProjectTasksEntriesAssigned] = useState(
    []
  );
  const [projectDescriptionsAssiged, setProjectDescriptionsAssiged] = useState(
    []
  );
  const [loggedEmp, setLoggedEmp] = useState({});
  const [tripDurationInput, setTripDuration] = useState();

  const handleTripDuration = (e) => {
    const value = e.target.value;
    setTripDuration(value);
  };

  const tripDuration =
    tripDurationInput ?? projectDescriptionsAssiged?.[0]?.tripduration ?? "";

  const [tripOpDurationInput, setOpTripDuration] = useState();
  console.log("installationvalue1 tripOpDurationInput", tripOpDurationInput);

  const handleOpTripDuration = (e) => {
    const value = e.target.value;
    setOpTripDuration(value);
  };

  const tripOpDuration =
    tripOpDurationInput ?? projectDescriptionsAssiged?.[0]?.tripduration ?? "";

  useEffect(() => {
    const Email = localStorage.getItem("email");
    const LoggedEmp = employees.find((emp) => emp.EmpEmail === Email);
    setLoggedEmp(LoggedEmp);
  }, [employees]);

  // Keep trip duration state scoped to the currently rendered assignee.
  // This prevents one operation person's value leaking to another row.
  useEffect(() => {
    const currentTripDuration = projectDescriptionsAssiged?.[0]?.tripduration ?? "";
    setTripDuration(currentTripDuration);
    setOpTripDuration(currentTripDuration);
  }, [emp?._id, projectDescriptionsAssiged]);

  console.log("installationvalue tripDuration", tripDuration);
  console.log("installationvalue emp", emp);

  const isSelfManager =
    emp?.fullName === "Self" ||
    (emp?.customRole?.[0] === "project manager" && emp?.customRole?.length === 1);
  const managerOnlyDescriptionList = useMemo(() => {
    if (isSelfManager && Array.isArray(emp?.DescriptionList)) {
      return emp.DescriptionList.filter((d) => {
        // Include only entries that belong to this manager
        if (d?.taskownerid == null || d?.taskownerid === "")
          return true; // legacy "self" entries without taskownerid
        return String(d.taskownerid) === String(emp._id);
      });
    }
    return emp?.DescriptionList;
  }, [isSelfManager, emp?.DescriptionList, emp?._id]);

  const descriptionListSyncKey = useMemo(
    () => JSON.stringify(managerOnlyDescriptionList ?? []),
    [managerOnlyDescriptionList]
  );

  useEffect(() => {
    setProjectTasksEntriesAssigned(
      emp?.workEntries?.length > 0
        ? emp.workEntries.map((entry) => ({ ...entry }))
        : []
    );
  }, [emp?._id, emp?.workEntries]);

  useEffect(() => {
    const list = Array.isArray(managerOnlyDescriptionList)
      ? managerOnlyDescriptionList.map((d) => ({ ...d }))
      : [];
    setProjectDescriptionsAssiged(consolidateTrainingExpenseRowsForDisplay(list));
  }, [emp?._id, descriptionListSyncKey, managerOnlyDescriptionList]);

  // Locked Training Cost row (display-only) for the currently selected person in Project Assigned view.
  // Uses the same training ↔ project linkage as finance / hardware sync so amounts match My Training.
  const lockedTrainingRow = useMemo(() => {
    if (!emp || !row) return null;
    return getLiveTrainingRollupForOpsAssigneeProject({
      projectRow: row,
      assigneeEmp: emp,
      trainingsEnvelope: mytrainings,
      projects,
      currencySymbol: currency,
    });
  }, [mytrainings, emp, row, currency, projects]);

  const lockedTrainingCostTotal = lockedTrainingRow
    ? Number(lockedTrainingRow.amount) || 0
    : 0;
  const shouldShowLockedTrainingRow =
    lockedTrainingCostTotal > 0 ||
    String(lockedTrainingRow?.notes || "").trim() !== "";

  /** When My Training has a resolved cost, hide stale persisted "Training Cost" description rows and avoid double totals. */
  const hidePersistedTrainingCostRows = lockedTrainingCostTotal > 0;

  const lockedTrainingNotes = String(lockedTrainingRow?.notes || "").trim();

  useEffect(() => {
    if (!(lockedTrainingCostTotal > 0)) return;
    setProjectDescriptionsAssiged((prev) => {
      const prevConsolidated = consolidateTrainingExpenseRowsForDisplay(prev || []);
      const manuals = (prevConsolidated || []).filter((r) => !isTrainingExpenseDisplayRow(r));
      const trains = (prevConsolidated || []).filter((r) => isTrainingExpenseDisplayRow(r));
      if (!trains.length) return prevConsolidated;
      const [template] = trains;
      const mergedTrain = {
        ...template,
        value: lockedTrainingCostTotal,
        notes: lockedTrainingNotes || String(template?.notes || "").trim(),
      };
      const same =
        trains.length === 1 &&
        Number(String(trains[0].value ?? "").replace(/,/g, "")) === lockedTrainingCostTotal;
      if (same) return prevConsolidated;
      return [...manuals, mergedTrain];
    });
  }, [lockedTrainingCostTotal, lockedTrainingNotes, emp?._id, descriptionListSyncKey]);

  // Display amount for Self: show only manager's value (no consolidated/operation sum). Never saved.
  const getDisplayAmount = (descriptionRow) => {
    const managerVal = Number(descriptionRow?.value) || 0;
    if (!isSelfManager) return managerVal;
    return managerVal;
  };

  const handleInputChange = (index, field, value) => {
    if (isViewOnly) return;
    setProjectTasksEntriesAssigned((prevRows) => {
      const newRows = [...prevRows];
      let validatedValue = value;
      if (field === "hoursassigned") {
        validatedValue = sanitizeDecimalInput(value);
      } else if (field === "task" || field === "notes") {
        validatedValue = value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
      }
      newRows[index] = {
        ...newRows[index],
        [field]: validatedValue,
      };
      return newRows;
    });
  };

  const handleAddTaskRow = () => {
    if (isViewOnly) return;
    if (projectTasksEntriesAssiged?.length === 0) {
      const newRow = { task: "", hoursassigned: "", notes: "" };
      setProjectTasksEntriesAssigned([newRow]);
    } else if (projectTasksEntriesAssiged.length < 15) {
      setProjectTasksEntriesAssigned([
        ...projectTasksEntriesAssiged,
        { task: "", hoursassigned: "", notes: "" },
      ]);
    } else {
    }
  };

  const handleRemoveTaskRow = (index) => {
    if (isViewOnly) return;
    setProjectTasksEntriesAssigned((prev) => {
      const rowToRemove = prev[index];
      if (
        prev.length === 1 &&
        rowToRemove.task === "" &&
        rowToRemove.hoursassigned === "" &&
        rowToRemove.notes === ""
      ) {
        return []; // remove the empty object
      }
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleTripInputChange = (index, field, value) => {
    const nextValue =
      field === "value" ? validateAmountValue(value) : value;
    setProjectDescriptionsAssiged((prev) => {
      const newRows = [...prev]; // shallow copy of array
      const updatedRow = { ...newRows[index], [field]: nextValue }; // clone object and update field
      newRows[index] = updatedRow; // replace with updated row
      return newRows;
    });
  };

  const handleAddRow = () => {
    if (isViewOnly) return;
    if (projectDescriptionsAssiged?.length === 0) {
      const newRow = {
        description: "",
        value: "",
        notes: "",
        ...(isSelfManager && emp?._id ? { taskownerid: emp._id } : {}),
      };
      setProjectDescriptionsAssiged([newRow]);
    } else if (projectDescriptionsAssiged.length < 15) {
      setProjectDescriptionsAssiged([
        ...projectDescriptionsAssiged,
        {
          description: "",
          value: "",
          notes: "",
          ...(isSelfManager && emp?._id
            ? { taskownerid: emp._id }
            : {}),
        },
      ]);
    } else {
    }
  };

  const handleRemoveRow = (index) => {
    const updatedRows = projectDescriptionsAssiged?.filter(
      (_, i) => i !== index
    );
    setProjectDescriptionsAssiged(updatedRows);
  };

  const validateDescriptionOrNotes = (value) => {
    return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
  };

  const handleWorkEntriesSubmit = async () => {
    if (isViewOnly) return;
    const cleanedEntries = projectTasksEntriesAssiged
      ?.filter((entry) => {
        return (
          entry?.task !== null &&
          entry?.task !== undefined &&
          entry?.task !== "" &&
          entry?.hoursassigned !== null &&
          entry?.hoursassigned !== undefined &&
          entry?.hoursassigned !== ""
        );
      })
      .map((entry) => ({
        _id: entry._id || null,
        task: entry.task,
        hoursassigned: entry.hoursassigned,
        hoursspent: entry.hoursspent,
        startdate: entry.startdate,
        enddate: entry.enddate,
        expenses: entry.expenses,
        notes: entry.notes,
        oldtaskid: entry.oldtaskid || null,
      }));

    const Payload = {
      projectid: selectedProjectId,
      tasktype: "other",
      taskownerid: emp._id,
      newEntries: cleanedEntries,
    };
    const projectId = selectedProjectId;
    setIsLoading(true);
    try {
      await dispatch(replaceWorkEntriesProjectTrack(Payload));
      await dispatch(setProjectReadTrue(projectId));

      enqueueSnackbar("WorkEntries Added", {
        variant: "success",
      });
      setIsLoading(false);
      dispatch(fetchAllProjects());
      dispatch(fetchWorkEntriesProjectTracking());
    } catch {
      enqueueSnackbar("Failed to save workentries", {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setProjectTasksEntriesAssigned(cleanedEntries);
      refreshAssign();
    }
  };

  const handleDescriptionEntriesSubmit = async () => {
    if (isViewOnly) return;
  const matchedTripOp = tripOpDurationInput || null;
    // For installation projects, if trip duration is changed, update ALL description entries
    const isInstallation = Array.isArray(row?.TypeService)
      ? row.TypeService.some(s => String(s ?? "").toLowerCase().includes("installation"))
      : String(row?.TypeService ?? "").toLowerCase().includes("installation");
    
    // Use projectDescriptionsAssiged (current form state) so operation person's edits (e.g. 5000) are saved, not stale emp.DescriptionList
    const allDescriptionEntries = projectDescriptionsAssiged || [];
    
    // If installation and trip duration is provided, update all entries with new trip duration
    let entriesToUpdate = allDescriptionEntries;
    if (isInstallation && matchedTripOp !== null && matchedTripOp !== undefined && String(matchedTripOp).trim() !== "") {
      entriesToUpdate = allDescriptionEntries.map(entry => ({
        ...entry,
        tripduration: Number(matchedTripOp)
      }));
    }
    
    // Filter to only valid entries (with description and value)
    const cleanedDescriptionEntries = entriesToUpdate
      ?.filter((entry) => {
        return (
          entry?.description !== null &&
          entry?.description !== undefined &&
          entry?.description !== "" &&
          entry?.value !== null &&
          entry?.value !== undefined &&
          entry?.value !== ""
        );
      })
      .map((entry) => ({
        _id: entry?._id || null,
        description: entry.description,
        value: entry.value,
        notes: entry.notes,
        oldtaskid: entry.oldtaskid || null,
        tripduration: isInstallation && matchedTripOp !== null && matchedTripOp !== undefined && String(matchedTripOp).trim() !== ""
          ? Number(matchedTripOp)
          : entry.tripduration,
      }));
    const Payload = {
      projectid: selectedProjectId,
      tasktype: "other",
      taskownerid: emp._id,
      entries: cleanedDescriptionEntries,
    };
      console.log("installationvalue1 Payload", Payload);

    const projectId = selectedProjectId;
    setIsLoading(true);
    try {
      await dispatch(saveUpdateDescriptionTask(Payload));
      await dispatch(setProjectReadTrue(projectId));
      enqueueSnackbar("Description Entries Added", {
        variant: "success",
      });
      setIsLoading(false);
      dispatch(fetchAllProjects());
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchDescriptionTasks()); // Refresh description tasks for Associated Costs table
    } catch {
      enqueueSnackbar("Failed to save Description", {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setProjectDescriptionsAssiged(
        consolidateTrainingExpenseRowsForDisplay(cleanedDescriptionEntries || [])
      );
      refreshAssign();
    }
  };

  const handleSelfWorkEntriesSubmit = async (index) => {
    if (isViewOnly) return;
    const cleanedEntries = projectTasksEntriesAssiged
      ?.filter((entry) => {
        return (
          entry?.task !== null &&
          entry?.task !== undefined &&
          entry?.task !== "" &&
          entry?.hoursassigned !== null &&
          entry?.hoursassigned !== undefined &&
          entry?.hoursassigned !== ""
        );
      })
      .map((entry) => ({
        _id: entry._id || null,
        task: entry.task,
        hoursassigned: entry.hoursassigned,
        hoursspent: entry.hoursspent,
        startdate: entry.startdate,
        enddate: entry.enddate,
        expenses: entry.expenses,
        notes: entry.notes,
        oldtaskid: entry.oldtaskid || null,
      }));

    const Payload = {
      projectid: row._id, // optional if API needs it
      tasktype: "self",
      newEntries: cleanedEntries,
    };
    const projectId = row?.projectid;

    setIsLoading(true);
    try {
      await dispatch(replaceWorkEntriesProjectTrack(Payload));
      await dispatch(setProjectReadTrue(projectId));
      enqueueSnackbar("WorkEntries Saved", {
        variant: "success",
      });
      dispatch(fetchAllProjects());
      dispatch(fetchWorkEntriesProjectTracking());
    } catch {
      enqueueSnackbar("Failed to save workentries", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
      setProjectTasksEntriesAssigned(cleanedEntries);
      refreshAssign();
    }
  };

  // Check if all tasks with task name have hours filled (for all managers and employees)
  const areAllTaskHoursFilled = () => {
    if (!projectTasksEntriesAssiged || projectTasksEntriesAssiged.length === 0) return true;
    
    // Filter rows that have a task name filled
    const rowsWithTask = projectTasksEntriesAssiged.filter(row => 
      row.task && row.task.trim() !== ""
    );
    
    // Check if all rows with task have hours filled
    return rowsWithTask.every(row => 
      row.hoursassigned !== undefined && 
      row.hoursassigned !== null && 
      row.hoursassigned.toString().trim() !== ""
    );
  };

  // Check if trip duration is required and filled (for installation managers/operations)
  const isTripDurationValid = () => {
    const isInstallation = Array.isArray(row?.TypeService)
      ? row.TypeService.some(s => String(s ?? "").toLowerCase().includes("installation"))
      : String(row?.TypeService ?? "").toLowerCase().includes("installation");
    
    if (!isInstallation) return true; // Not installation, no validation needed
    
    // Check if user is manager or operations person
    const isManager = emp?.customRole?.some(role => 
      (role ?? "").toLowerCase().includes("project manager") || 
      (role ?? "").toLowerCase().includes("manager")
    );
    const isOperations = emp?.customRole?.some(role => 
      (role ?? "").toLowerCase().includes("operations")
    );
    
    if (!isManager && !isOperations) return true; // Not manager or operations, no validation needed
    
    // For installation managers/operations, check if trip duration is filled
    const currentTripDuration = emp?.customRole?.some(role => 
      (role ?? "").toLowerCase().includes("project manager")
    ) ? tripDuration : tripOpDuration;
    
    return currentTripDuration !== undefined && 
           currentTripDuration !== null && 
           String(currentTripDuration).trim() !== "";
  };

  const handleSelfDescriptionEntriesSubmit = async () => {
    if (isViewOnly) return;
    // For installation projects, if trip duration is changed, update ALL description entries
    const isInstallation = Array.isArray(row?.TypeService)
      ? row.TypeService.some(s => String(s ?? "").toLowerCase().includes("installation"))
      : String(row?.TypeService ?? "").toLowerCase().includes("installation");
    
    // Use projectDescriptionsAssiged so we save manager's actual values (entry.value), never the displayed sum for common descriptions
    const allDescriptionEntries = projectDescriptionsAssiged || [];
    
    // If installation and trip duration is provided, update all entries with new trip duration
    let entriesToUpdate = allDescriptionEntries;
    if (isInstallation && tripDuration !== null && tripDuration !== undefined && String(tripDuration).trim() !== "") {
      entriesToUpdate = allDescriptionEntries.map(entry => ({
        ...entry,
        tripduration: Number(tripDuration)
      }));
    }
    
    // Filter to only valid entries (with description and value). For manager (Self), send manager-only amount so operation person amount is not merged in.
    const cleanedDescriptionEntries = entriesToUpdate
      ?.filter((entry) => {
        return (
          entry?.description !== null &&
          entry?.description !== undefined &&
          entry?.description !== "" &&
          entry?.value !== null &&
          entry?.value !== undefined &&
          entry?.value !== ""
        );
      })
      .map((entry) => ({
        _id: entry?._id || null,
        description: entry.description,
        value: isSelfManager ? parseAmountNumber(entry.value) : entry.value,
        notes: entry.notes,
        oldtaskid: entry.oldtaskid || null,
        tripduration: isInstallation && tripDuration !== null && tripDuration !== undefined && String(tripDuration).trim() !== ""
          ? Number(tripDuration)
          : entry.tripduration,
      }));

    const Payload = {
      projectid: selectedProjectId,
      tasktype: "self",
      entries: cleanedDescriptionEntries,
    };
    const projectId = selectedProjectId;
    console.log("installationvalue Payload", Payload);

    setIsLoading(true);
    try {
      await dispatch(saveUpdateDescriptionTask(Payload));
      await dispatch(setProjectReadTrue(projectId));

      enqueueSnackbar("Description Entries Saved", {
        variant: "success",
      });
      setIsLoading(false);
      dispatch(fetchAllProjects());
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchDescriptionTasks()); // Refresh description tasks for Associated Costs table
    } catch {
      enqueueSnackbar("Failed to save Description", {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setProjectDescriptionsAssiged(
        consolidateTrainingExpenseRowsForDisplay(cleanedDescriptionEntries || [])
      );
      refreshAssign();
    }
  };

  // After submit, neither manager nor operation person can edit Other Expenses
  const isLockedAfterSubmit = emp?.Assignedperson?.projecttracktaskStatus === "submit";

  return (
    <>
      <div className="w-full h-full">
        {clickedPersonId === emp?._id ? (
          <>
            {showListState === "tasktable" && (
              <>
                <div
                  onClick={(e) => {
                    e.stopPropagation(); // prevent row onClick from firing
                  }}
                  className="flex w-full overflow-auto"
                >
                  <div className="w-full max-h-[14rem]">
                    <div className="sticky top-0 flex text-center bg-blue-500 text-white text-[11px] z-20">
                      <div className="w-[45%] border p-1">Task</div>
                      <div className="w-[20%] border p-1">Hrs</div>
                      <div className="w-[35%] border p-1">Notes</div>
                    </div>

                    {/* Second header row (Total) */}
                    <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                      <div className="w-[45%] border p-1">Total</div>
                      <div className="w-[20%] border p-1">
                        {roundHours(
                          projectTasksEntriesAssiged?.reduce((sum, item) => {
                            return sum + (parseFloat(item.hoursassigned) || 0);
                          }, 0) || 0
                        )}
                      </div>
                      <div className="w-[35%] border p-1"></div>
                    </div>

                    <div className="w-full">
                      {projectTasksEntriesAssiged.map((row, index) => {
                        const matchedOldWorkEntry = matchedOldRowEntries.find(
                          (old) => old._id === row.oldtaskid
                        );
                        return (
                          <React.Fragment key={index}>
                            <div className="flex items-center text-center w-full text-[11px]">
                              <div className="head flex w-full">
                                {/* Task Input */}
                                <div
                                  className="w-[45%] border border-white"
                                  title={
                                    matchedOldWorkEntry
                                      ? `Previous Name: ${matchedOldWorkEntry.task}`
                                      : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    name="task"
                                    value={row.task || ""}
                                    onChange={(e) => {
                                      const validValue = e.target.value.replace(
                                        /[^a-zA-Z0-9 ]/g,
                                        ""
                                      );
                                      handleInputChange(
                                        index,
                                        "task",
                                        validValue
                                      );
                                    }}
                                    className={`outline-none border-none text-center w-full h-full p-1 ${row.lastEditedFields?.includes("task")
                                      ? "bg-gray-400 text-white border "
                                      : "border border-white bg-gray-200"
                                      }`}
                                  />
                                </div>

                                {/* Hours Input */}
                                <div
                                  className="w-[20%] border border-white"
                                  title={
                                    matchedOldWorkEntry
                                      ? `Previous Hrs: ${matchedOldWorkEntry.hoursassigned}`
                                      : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    name="hoursassigned"
                                    value={row.hoursassigned || ""}
                                    onKeyDown={(e) => {
                                      if (
                                        ["e", "E", "+", "-"].includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      const value = sanitizeDecimalInput(e.target.value);
                                      handleInputChange(
                                        index,
                                        "hoursassigned",
                                        value
                                      );
                                    }}
                                    className={`outline-none border-none text-center w-full h-full p-1 ${row.lastEditedFields?.includes(
                                      "hoursassigned"
                                    )
                                      ? "bg-gray-400 text-white border "
                                      : "border border-white bg-gray-200"
                                      }`}
                                  />
                                </div>

                                {/* Notes Input */}
                                <div
                                  className="w-[35%] border border-white"
                                  title={
                                    matchedOldWorkEntry
                                      ? `Previous Notes: ${matchedOldWorkEntry.notes}`
                                      : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    name="notes"
                                    value={row.notes || ""}
                                    onChange={(e) => {
                                      const validValue = e.target.value.replace(
                                        /[^a-zA-Z0-9]/g,
                                        ""
                                      );
                                      handleInputChange(
                                        index,
                                        "notes",
                                        validValue
                                      );
                                    }}
                                    className={`outline-none border-none text-center w-full h-full p-1 ${row.lastEditedFields?.includes("notes")
                                      ? "bg-gray-400 text-white border "
                                      : "border border-white bg-gray-200"
                                      }`}
                                  />
                                </div>
                              </div>
                            </div>

                            {!(
                              (emp.fullName === "Self" ||
                                emp.customRole[0] === "project manager" ||
                                emp.customRole[0] === "operations") &&
                              emp?.Assignedperson?.projecttracktaskStatus ===
                              "submit"
                            ) && (
                                <>
                                  {emp.Assignedperson?.operationaction !==
                                    "reject" && (
                                      <>
                                        {(emp.Assignedperson
                                          ?.projecttracktaskStatus === "pending" ||
                                          (!(
                                            emp.Assignedperson?.manageraction ===
                                            "complete" ||
                                            emp.Assignedperson?.operationaction ===
                                            "complete"
                                          ) &&
                                            emp.Assignedperson
                                              ?.projecttracktaskStatus ===
                                            "submit")) && (
                                            <>
                                              {index ===
                                                projectTasksEntriesAssiged.length -
                                                1 && (
                                                  <div className="flex justify-between px-2 pt-1 pb-2">
                                                    <button
                                                      className="shadow-xl rounded-md p-1 bg-gray-100 hover:bg-gray-200"
                                                      onClick={handleAddTaskRow}
                                                      title="Add row"
                                                    >
                                                      <AddIcon fontSize="small" />
                                                    </button>
                                                    <button
                                                      className="shadow-xl rounded-md p-1 bg-gray-100 hover:bg-gray-200"
                                                      onClick={() => {
                                                        handleRemoveTaskRow(index);
                                                        dispatch(
                                                          deleteTask([row?._id])
                                                        );
                                                      }}
                                                      title="Remove row"
                                                    >
                                                      <RemoveIcon fontSize="small" />
                                                    </button>
                                                  </div>
                                                )}
                                            </>
                                          )}
                                      </>
                                    )}
                                </>
                              )}
                          </React.Fragment>
                        );
                      })}

                      {projectTasksEntriesAssiged.length === 0 && (
                        <div className="flex justify-start px-2 pt-1 ">
                          <button
                            className="shadow-xl rounded-md p-1"
                            onClick={handleAddTaskRow}
                          >
                            <AddIcon fontSize="small" />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {showListState === "otherexpenses" && (
              <div className="w-full overflow-auto justify-center pb-2">
                <div className="max-h-[14rem] ">
                  <div className="sticky top-0 flex text-center bg-blue-500 text-white text-[11px] z-20">
                    <div className="w-[45%] border p-1">Descriptions</div>
                    <div className="w-[20%] border p-1">
                      Amount ({currency})
                    </div>
                    <div className="w-[35%] border p-1">Notes</div>
                  </div>

                    <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                    <div className="w-[45%] border p-1">Total</div>
                    <div className="w-[20%] border p-1">
                      {formatAmountComma(
                          (isSelfManager
                            ? projectDescriptionsAssiged?.reduce(
                                (sum, item) =>
                                  hidePersistedTrainingCostRows && isTrainingExpenseDisplayRow(item)
                                    ? sum
                                    : sum + getDisplayAmount(item),
                                0
                              )
                            : projectDescriptionsAssiged?.reduce((sum, item) => {
                                if (hidePersistedTrainingCostRows && isTrainingExpenseDisplayRow(item)) {
                                  return sum;
                                }
                                return (
                                  sum + parseAmountNumber(item.value)
                                );
                              }, 0)) +
                            (shouldShowLockedTrainingRow ? lockedTrainingCostTotal : 0)
                      )}
                    </div>
                    <div className="w-[35%] border p-1"></div>
                  </div>
                  {(String(row?.TypeService ?? "").toLowerCase().includes("installation")) && (
                    <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                      <div className="w-[45%] border p-1 flex justify-center items-center">
                        Trip Duration
                      </div>
                      <div className="w-[20%] border p-1 ">
                        {(() => {
                          // Check if trip duration should be disabled
                          // Disable if: projecttracktaskStatus === "submit" OR action is "complete"
                          const isSubmitted = emp?.Assignedperson?.projecttracktaskStatus === "submit";
                          const isComplete = emp?.Assignedperson?.manageraction === "complete" || 
                                           emp?.Assignedperson?.operationaction === "complete";
                          const isDisabled = isSubmitted || isComplete;
                          
                          // Check if user is installation manager or installation employee
                          const isInstallationManager = emp?.customRole?.some(role => 
                            (role ?? "").toLowerCase().includes("project manager") || 
                            (role ?? "").toLowerCase().includes("manager")
                          );
                          const isInstallationEmployee = emp?.customRole?.some(role => 
                            (role ?? "").toLowerCase().includes("operations")
                          );
                          const shouldDisable = (isInstallationManager || isInstallationEmployee) && isDisabled;
                          
                          return emp?.customRole?.includes("project manager") ? (
                          <>
                            <input
                              value={tripDuration}
                              type="text"
                              name="tripduration"
                              placeholder="trip duration"
                              onChange={handleTripDuration}
                                disabled={shouldDisable}
                                className={`outline-none border-none text-center w-full h-full p-0.5 border border-white text-black rounded-md ${shouldDisable ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                            />
                          </>
                          ) : (
                            <>
                          <input
                            value={tripOpDuration}
                            type="text"
                            name="tripduration"
                            placeholder="trip duration"
                            onChange={handleOpTripDuration}
                                disabled={shouldDisable}
                                className={`outline-none text-center w-full h-full p-0.5 border border-white text-black rounded-md ${shouldDisable ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                          />
                            </>
                          );
                        })()}

                      </div>
                      <div className="w-[35%] border p-1"></div>
                    </div>
                  )}

                  <div className="w-full">
                    {projectDescriptionsAssiged?.map((row, index) => {
                      if (hidePersistedTrainingCostRows && isTrainingExpenseDisplayRow(row)) {
                        return (
                          <React.Fragment key={row?._id || row?.oldtaskid || `hidetr-${index}`} />
                        );
                      }
                      const matchedOldDescription =
                        matchedOldRowDesctiption.find(
                          (old) => old._id === row.oldtaskid
                        );
                      return (
                        <React.Fragment key={index}>
                          <div className="flex items-center text-center w-full text-[11px]">
                            <div className="w-full">
                              <div className="head flex">
                                <div
                                  className="w-[45%] border border-white"
                                  title={
                                    matchedOldDescription
                                      ? `Previous Name: ${matchedOldDescription.description}`
                                      : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    name="description"
                                    value={row.description}
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "description",
                                        validateDescriptionOrNotes(
                                          e.target.value
                                        )
                                      )
                                    }
                                    readOnly={isLockedAfterSubmit}
                                    className={`outline-none border-none text-center w-full h-full p-1 ${row.lastEditedFields?.includes(
                                      "description"
                                    )
                                      ? "bg-gray-400 text-white border "
                                      : "border border-white bg-gray-200"
                                      } ${isLockedAfterSubmit ? "cursor-default bg-gray-100" : ""}`}
                                  />
                                </div>

                                <div
                                  className="w-[20%] border border-white"
                                  title={
                                    matchedOldDescription
                                      ? `Previous Value: ${matchedOldDescription.value}`
                                      : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    name="value"
                                    value={formatAmountForInput(row.value)}
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "value",
                                        validateAmountValue(e.target.value)
                                      )
                                    }
                                    readOnly={isLockedAfterSubmit}
                                    onKeyDown={(e) => {
                                      if (
                                        ["e", "E", "+", "-"].includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className={`outline-none border-none text-center w-full h-full p-1 ${row.lastEditedFields?.includes("value")
                                      ? "bg-gray-400 text-white border "
                                      : "border border-white bg-gray-200"
                                      } ${isLockedAfterSubmit ? "cursor-default bg-gray-100" : ""}`}
                                  />
                                </div>

                                <div
                                  className="w-[35%] border border-white"
                                  title={
                                    matchedOldDescription
                                      ? `Previous Notes: ${matchedOldDescription.notes}`
                                      : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    name="notes"
                                    value={row.notes}
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "notes",
                                        validateDescriptionOrNotes(
                                          e.target.value
                                        )
                                      )
                                    }
                                    readOnly={isLockedAfterSubmit}
                                    className={`outline-none border-none text-center w-full h-full p-1 ${row.lastEditedFields?.includes("notes")
                                      ? "bg-gray-400 text-white border "
                                      : "border border-white bg-gray-200"
                                      } ${isLockedAfterSubmit ? "cursor-default bg-gray-100" : ""}`}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {!(
                            (emp.fullName === "Self" ||
                              emp.customRole[0] === "project manager" ||
                              emp.customRole[0] === "operations") &&
                            emp?.Assignedperson?.projecttracktaskStatus ===
                            "submit"
                          ) && (
                              <>
                                {emp.Assignedperson?.operationaction !==
                                  "reject" && (
                                    <>
                                      {/* moved + / - controls below all rows (including Training Cost) */}
                                    </>
                                  )}
                              </>
                            )}
                        </React.Fragment>
                      );
                    })}

                    {shouldShowLockedTrainingRow && lockedTrainingRow && (
                      <div className="flex items-center text-center w-full text-[11px]">
                        <div className="w-full">
                          <div className="head flex">
                            <div className="w-[45%] border border-white">
                              <input
                                type="text"
                                value={lockedTrainingRow.description}
                                readOnly
                                className="outline-none border-none text-center w-full h-full p-1 border border-white bg-gray-100 cursor-default"
                              />
                            </div>
                            <div className="w-[20%] border border-white">
                              <input
                                type="text"
                                value={formatAmountComma(lockedTrainingRow.amount)}
                                readOnly
                                className="outline-none border-none text-center w-full h-full p-1 border border-white bg-gray-100 cursor-default"
                              />
                            </div>
                            <div className="w-[35%] border border-white">
                              <input
                                type="text"
                                value={lockedTrainingRow.notes}
                                readOnly
                                className="outline-none border-none text-center w-full h-full p-1 border border-white bg-gray-100 cursor-default"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!(
                      (emp.fullName === "Self" ||
                        emp.customRole[0] === "project manager" ||
                        emp.customRole[0] === "operations") &&
                      emp?.Assignedperson?.projecttracktaskStatus === "submit"
                    ) &&
                      emp.Assignedperson?.operationaction !== "reject" &&
                      (emp.Assignedperson?.projecttracktaskStatus === "pending" ||
                        (!(
                          emp.Assignedperson?.manageraction === "complete" ||
                          emp.Assignedperson?.operationaction === "complete"
                        ) &&
                          emp.Assignedperson?.projecttracktaskStatus === "submit")) && (
                        <div className="flex justify-between px-2 pt-1">
                          <button
                            className="shadow-xl rounded-md p-1"
                            onClick={handleAddRow}
                            disabled={projectDescriptionsAssiged?.length >= 15}
                          >
                            <AddIcon />
                          </button>
                          <button
                            className="shadow-xl rounded-md p-1"
                            onClick={() => {
                              const lastIdx = (projectDescriptionsAssiged?.length || 0) - 1;
                              if (lastIdx < 0) return;
                              handleRemoveRow(lastIdx);
                              dispatch(deleteDescriptionTask(row?._id));
                            }}
                          >
                            <RemoveIcon />
                          </button>
                        </div>
                      )}

                    {emp.Assignedperson?.projecttracktaskStatus !== "submit" &&
                      projectDescriptionsAssiged.length === 0 && (
                        <div className="flex justify-start px-2 pt-1 ">
                          <button
                            className="shadow-xl rounded-md p-1"
                            onClick={handleAddRow}
                          >
                            <AddIcon fontSize="small" />
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            )}

            {emp.Assignedperson?.operationaction !== "reject" && (
              <>
                {(emp.Assignedperson?.projecttracktaskStatus === "pending" ||
                  (!(
                    emp.Assignedperson?.manageraction === "complete" ||
                    emp.Assignedperson?.operationaction === "complete"
                  ) &&
                    emp.Assignedperson?.projecttracktaskStatus ===
                    "submit")) && (
                    <>
                      {(showListState === "otherexpenses" ||
                        showListState === "tasktable") && (
                          <div className="flex justify-end mb-2 mr-2">
                            {projectTasksEntriesAssiged.some(
                              (row) =>
                                row.taskownerid === loggedEmp._id &&
                                loggedEmp.customRoles?.includes("project manager")
                            ) ? (
                              <>
                                {!(
                                  (emp.fullName === "Self" ||
                                    emp.customRole[0] === "project manager" ||
                                    emp.customRole[0] === "operations") &&
                                  emp?.Assignedperson?.projecttracktaskStatus ===
                                  "submit"
                                ) && (
                                    <button
                                      disabled={isViewOnly}
                                      onClick={() => {
                                        if (isViewOnly) return;
                                        if (!areAllTaskHoursFilled()) {
                                          enqueueSnackbar("Please fill all the field.", {
                                            variant: "error",
                                          });
                                          return;
                                        }
                                        if (!isTripDurationValid()) {
                                          enqueueSnackbar("Please add Trip Duration.", {
                                            variant: "error",
                                          });
                                          return;
                                        }
                                        handleSelfWorkEntriesSubmit();
                                        handleSelfDescriptionEntriesSubmit();
                                      }}
                                      className={`px-2 py-1 rounded-md ${isViewOnly
                                        ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60 pointer-events-none"
                                        : !areAllTaskHoursFilled() || !isTripDurationValid()
                                          ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                                          : "bg-blue-600 hover:bg-blue-800 text-white"
                                      }`}
                                    >
                                      Submit
                                    </button>
                                  )}
                              </>
                            ) : (
                              <>
                                <>
                                  {!(
                                    (emp.fullName === "Self" ||
                                      emp.customRole[0] === "project manager" ||
                                      emp.customRole[0] === "operations") &&
                                    emp?.Assignedperson?.projecttracktaskStatus ===
                                    "submit"
                                  ) && (
                                      <button
                                        disabled={isViewOnly}
                                        onClick={() => {
                                          if (isViewOnly) return;
                                          if (!areAllTaskHoursFilled()) {
                                            enqueueSnackbar("Please fill all the field.", {
                                              variant: "error",
                                            });
                                            return;
                                          }
                                          if (!isTripDurationValid()) {
                                            enqueueSnackbar("Please add Trip Duration.", {
                                              variant: "error",
                                            });
                                            return;
                                          }
                                          handleWorkEntriesSubmit();
                                          handleDescriptionEntriesSubmit();
                                        }}
                                        className={`px-2 py-1 rounded-md ${isViewOnly
                                          ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60 pointer-events-none"
                                          : !areAllTaskHoursFilled() || !isTripDurationValid() || 
                                          (projectDescriptionsAssiged?.length === 0 &&
                                           projectTasksEntriesAssiged.length === 0)
                                            ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                                            : "bg-blue-600 hover:bg-blue-800 text-white"
                                        }`}
                                      >
                                        Submit
                                      </button>
                                    )}
                                </>
                              </>
                            )}
                          </div>
                        )}
                    </>
                  )}
              </>
            )}
          </>
        ) : (
          <div
            onClick={() =>
              setClickedPersonId(clickedPersonId === emp?._id ? null : emp?._id)
            }
            className="h-full flex-1 flex justify-center items-center align-middle"
          >
            Task Details
          </div>
        )}
      </div>
    </>
  );
};

export default ShowAssigedTableManager;
